module.exports = __webpack_public_path__ + "static/media/AgriECO.34ae29b1.svg";